import React from 'react';
import { Outlet } from 'react-router-dom';

function AgentLayout(props) {
    return (
        <Outlet />
    );
}

export default AgentLayout;